/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_LayoutsInputs */

const en_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Layouts`)
};

const es_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseños de página`)
};

const fr_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mises en page`)
};

const de_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenlayouts`)
};

const ja_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページレイアウト`)
};

const zh_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面排版`)
};

const ar_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخطيطات الصفحة`)
};

const id_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tata Letak Halaman`)
};

const it_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout di pagina`)
};

const ru_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макеты страниц`)
};

const pt_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layouts de página`)
};

const ko_page_layouts = /** @type {(inputs: Page_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 레이아웃`)
};

/**
* | output |
* | --- |
* | "Page Layouts" |
*
* @param {Page_LayoutsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_layouts = /** @type {((inputs?: Page_LayoutsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_LayoutsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_layouts(inputs)
	if (locale === "es") return es_page_layouts(inputs)
	if (locale === "fr") return fr_page_layouts(inputs)
	if (locale === "de") return de_page_layouts(inputs)
	if (locale === "ja") return ja_page_layouts(inputs)
	if (locale === "zh") return zh_page_layouts(inputs)
	if (locale === "ar") return ar_page_layouts(inputs)
	if (locale === "id") return id_page_layouts(inputs)
	if (locale === "it") return it_page_layouts(inputs)
	if (locale === "ru") return ru_page_layouts(inputs)
	if (locale === "pt") return pt_page_layouts(inputs)
	return ko_page_layouts(inputs)
});